import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import TimeSlot from './TimeSlot';
import { dayOfWeek2Text, month2Text } from '../Utils';
import { CALENDAR_DAY_END_HOUR, CALENDAR_DAY_START_HOUR, SLOT_HEIGHT, TASK_AVAILABILITY_TYPE } from './Constants';
import Task from './Task';
import { calculatePositionFromTime, isToday } from './Utils';
import Booking from './Booking';

const DayTimeColumn = ({}) => {
  const hours = Array.from({ length: CALENDAR_DAY_END_HOUR - CALENDAR_DAY_START_HOUR }, (_, i) => CALENDAR_DAY_START_HOUR + i);
  const lastHour = hours[hours.length -1];

  return (
    <div className={cn('dayColumn dayTimeColumn')}>
      <div className="header">
        <div className="day">&nbsp;</div>
        <div className="date">&nbsp;</div>
      </div>
      <div className="slots" >
        {hours.map(hour => (
          <TimeSlot key={hour} hour={hour} showTime={true} bottomHour={lastHour === hour} />
        ))}
      </div>
    </div>
  );
};

export default DayTimeColumn;



// WEBPACK FOOTER //
// ./app/javascript/components/designer_calendars/components/DayTimeColumn.js